import { useState } from "react";
import ListType from "types/ListType";
import BookActivity from "components/feed/BookActivity";
import pluralize from "lib/pluralize";
import PrivacyIcon from "components/shared/PrivacyIcon";
import Text from "hardcover-ui/components/Text";
import TextLink from "hardcover-ui/components/TextLink";
import BookGroupBooks from "components/BookGroup/books/BookGroupBooks";
import ActivityProps from "./ActivityFeedItemProps";
import { BookSerializersBookByline } from "types/serializers";

interface ListActivityType extends ListType {
  path: string;
}
interface ListActivityDataType {
  list: ListActivityType;
}

export default function ListActivity({ activity }: ActivityProps) {
  const [list] = useState((activity.data as ListActivityDataType).list);
  const books = list.listBooks.map((listBook) => listBook.book);

  return (
    <div className="space-y-4">
      <BookActivity activity={activity}>
        <p className="text-lg text-stone-800 dark:text-yellow-50">
          <Text variant="secondary">Added to list</Text>
          <span className="inline-flex items-center gap-2 px-1">
            <PrivacyIcon privacySettingId={list.privacySettingId} size="md" />
            <TextLink
              size="lg"
              href={list.path[0] === "/" ? list.path : `/${list.path}`}
            >
              {list.name}
            </TextLink>
          </span>
          <Text variant="secondary">
            with {list.booksCount} {pluralize("book", list.booksCount)}.
          </Text>
        </p>
      </BookActivity>

      {books.length >= 3 && (
        <BookGroupBooks
          size="md"
          books={books.slice(0, 7) as unknown as BookSerializersBookByline[]}
          context={{
            activeBook: activity.book,
            referrerId: activity.userId
          }}
        />
      )}
    </div>
  );
}
